import React from 'react'

const InputOutline = ({children,type,name,id,value,change}) => {
	return (
		<input 
			className="border border-gray-300 text-gray-900 dark:text-white text-[13px] rounded-lg focus:ring-black_m-300 focus:border-black_m-300 block w-full p-2.5" 
			type={type} 
			placeholder={children} 
			id={id}
			name={name}
			value={value}
			onChange={change}
		/>
	)
}

export default InputOutline